module.exports = __webpack_public_path__ + "img/no-search-img.182ca66c.png";